<template>
  <div
    class="wrapper"
    @click="onOpen"
  >
    <div class="inner">
      <div class="inner2">
        <img :src="photo" class="photo">
      </div>
    </div>

    <teleport v-if="isOpen" to="body">
      <div
        class="modal"
        @click.self="onClose"
      >
        <div class="modal__content">
          <img :src="photo" class="modal__image">

          <div
            class="modal__close"
            @click="onClose"
          >
            &#10006;
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'AppGalleryItem',
  props: {
    photo: {
      type: String,
      default: ''
    },
    canOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    click: null
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    onOpen () {
      this.$emit('click')

      if (!this.canOpen) { return }
      this.isOpen = true
    },
    onClose () {
      this.isOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;

  .inner {
    padding-bottom: 100%;
    width: 100%;

    .inner2 {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      .photo {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);

  &__content {
    position: relative;
    display: inline-block;
  }

  &__close {
    position: absolute;
    font-size: 24px;
    top: -24px;
    right: -24px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: red;
      cursor: pointer;
    }
  }

  &__image {
    max-width: 90vw;
    max-height: 90vh;
  }
}
</style>
